import { render, staticRenderFns } from "./GlobalSearchText.vue?vue&type=template&id=0132cf74&scoped=true&"
import script from "./GlobalSearchText.vue?vue&type=script&lang=js&"
export * from "./GlobalSearchText.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSearchText.vue?vue&type=style&index=0&id=0132cf74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0132cf74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTextField,VTooltip})
